module.exports = __webpack_public_path__ + "ab34ed29ded11ffb76410dddf700f6f8.png";